import { render, staticRenderFns } from "./EventModalDetailPass.vue?vue&type=template&id=4fdfe222&scoped=true"
import script from "./EventModalDetailPass.vue?vue&type=script&lang=js"
export * from "./EventModalDetailPass.vue?vue&type=script&lang=js"
import style0 from "./EventModalDetailPass.vue?vue&type=style&index=0&id=4fdfe222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdfe222",
  null
  
)

export default component.exports